import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to synchronize authentication state across multiple tabs
 * Handles token refresh broadcasts and logout synchronization
 */
export const useAuthSync = () => {
  const { isInitialized } = useAuth();

  useEffect(() => {
    if (!isInitialized || !window.BroadcastChannel) return;

    const channel = new BroadcastChannel('auth-channel');

    // Listen for messages from other tabs
    channel.onmessage = (event) => {
      const { type, token, timestamp } = event.data;

      switch (type) {
        case 'TOKEN_REFRESHED':
          // Update local storage with the new token from another tab
          if (token && timestamp) {
            localStorage.setItem('authToken', token);
            localStorage.setItem('tokenTimestamp', timestamp.toString());
            console.log('Token synchronized from another tab');
          }
          break;

        case 'LOGOUT':
          // Handle logout from another tab
          console.log('Logout synchronized from another tab');
          ['authToken', 'tokenTimestamp', 'userId', 'userName', 'userEmail',
            'userCreatedAt', 'userLastLogin', 'companyId', 'companyName'].forEach(
            key => localStorage.removeItem(key)
          );
          window.location.href = '/';
          break;

        default:
          break;
      }
    };

    // Cleanup on unmount
    return () => {
      channel.close();
    };
  }, [isInitialized]);

  // Function to broadcast token refresh to other tabs
  const broadcastTokenRefresh = (token, timestamp) => {
    if (window.BroadcastChannel) {
      const channel = new BroadcastChannel('auth-channel');
      channel.postMessage({
        type: 'TOKEN_REFRESHED',
        token,
        timestamp
      });
      channel.close();
    }
  };

  // Function to broadcast logout to other tabs
  const broadcastLogout = () => {
    if (window.BroadcastChannel) {
      const channel = new BroadcastChannel('auth-channel');
      channel.postMessage({ type: 'LOGOUT' });
      channel.close();
    }
  };

  return {
    broadcastTokenRefresh,
    broadcastLogout
  };
};